import { useState } from "react";

import type PartySocket from "partysocket";

import { DocumentManagerUI } from "./DocumentManagerUI";
import { FAQManagerUI } from "./FAQManagerUI";
import { KnowledgeAskUI } from "./KnowledgeAskUI";
import {
  type KnowledgeTab,
  KnowledgeTabSelector,
} from "./KnowledgeTabSelector";

export interface OrganisationKnowledgeManagerUIProps {
  partySocket: PartySocket;
}

export function OrganisationKnowledgeManagerUI({
  partySocket,
}: Readonly<OrganisationKnowledgeManagerUIProps>) {
  const [activeTab, setActiveTab] = useState<KnowledgeTab>("documents");

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="p-4">
        <KnowledgeTabSelector
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
      <div className="flex-grow overflow-hidden">
        {activeTab === "documents" && (
          <DocumentManagerUI partySocket={partySocket} />
        )}
        {activeTab === "faqs" && <FAQManagerUI partySocket={partySocket} />}
        {activeTab === "ask" && <KnowledgeAskUI />}
      </div>
    </div>
  );
}
